export default "__VITE_ASSET__y1m_eKPS__"